import initializeApplication from './initialize';
import { useEffect } from 'react';
import PrimaryRouter from './primary-router/PrimaryRouter';
import Essentials from './Essentials';

function Main() {
  useEffect(() => {
    initializeApplication();
  }, []);

  return (
    <>
      <Essentials />
      <PrimaryRouter />
    </>
  );
}

export default Main;
